



























import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { PayrollRunDetailsModule } from '@/store/modules/payrollRunDetails';
import PayrollRunDto from '@/models/Payroll/PayrollRunDto';
import PayrollRunStatus from '@/models/Payroll/PayrollRunStatus';

interface StatusOption {
    value: number;
    label: string;
}

@Component({
    name: 'PayrollRunStatusEdit'
})
export default class extends GiganautVue {

    @Prop({ required: true }) run!: PayrollRunDto;

    // Legal MANUAL transitions per current status. Everything else is
    // automatic (Draft → Submitting on first push; Submitting → Submitted
    // when everything is sent; Syncing Data → Completed when every worker
    // has payslip + holiday).
    get options(): StatusOption[] {
        switch (this.run.status) {
            case PayrollRunStatus.Submitting:
                return [{ value: PayrollRunStatus.Submitted, label: 'Submitted' }];
            case PayrollRunStatus.Submitted:
                return [
                    { value: PayrollRunStatus.Submitting, label: 'Submitting (reopen)' },
                    { value: PayrollRunStatus.SyncingData, label: 'Syncing Data' },
                ];
            default:
                return [];
        }
    }

    async setStatus(status: number) {
        await PayrollRunDetailsModule.updateStatus({ id: this.run.id, status });
    }
}
